// @flow
import React, { Fragment } from 'react';

import { t } from 'Src/i18n';
import { Capsule } from 'Components/frameworks/capsule/Capsule';
import { COLORS } from 'Components/utils/color/colors';
import { Button } from 'Components/frameworks/button/Button';
import { Flipper } from 'Components/frameworks/flipper/Flipper';
import { formatDate } from 'Utils/date/dateUtils';
import { DateSummary } from 'Components/widgets/package/price/DateSummary';

type Props = {|
  suggestion: $ReadOnly<{
    resortArrivalDate: string,
    resortDepartureDate: string,
    price: $ReadOnly<{
      total: string,
    }>,
  }>,
  onSubmit: (args: *) => void,
  categoryGA?: string,
  buttonLabel: string,
  title?: string | Node,
|};

export function AlternativeSuggestionCriteria({
  title,
  suggestion,
  onSubmit,
  buttonLabel,
  categoryGA = 'resort',
}: Props) {
  const getFormattedDate = formatDate('D MMMM YYYY');

  return (
    <div
      data-testid="AlternativeDateSuggestionCriteria"
      className="AlternativeProposalsModal-criteria rtl:mr-4 mt-8"
    >
      {title}
      <Capsule
        additionalStyle={{
          content: { padding: '20px', fontSize: '14px' },
        }}
      >
        <DateSummary
          template={t('booking.counterProposalPopIn.fromTo')}
          values={{
            arrivalDate: getFormattedDate(suggestion.resortArrivalDate, 'YYYYMMDD') || '',
            departureDate: getFormattedDate(suggestion.resortDepartureDate, 'YYYYMMDD') || '',
          }}
        />
        <div className="AlternativeProposalsModal-criteriaPrice flex font-bold font-bold items-center ml-10 justify-center text-blue">
          <Flipper value={suggestion.price.total} />
          <Fragment>
            <span className="AlternativeProposalsModal-criteriaLabelPrice ml-2 rtl:ml-2">
              &nbsp;
              <Flipper value={t('booking.priceDetails.packagePrice.totalPrice')} />
              &nbsp;
            </span>
            <span>&nbsp;</span>
          </Fragment>
        </div>
        <Button
          dataTestId="AlternativeProposalsModalButton"
          className="w-full mt-2"
          color={COLORS.WHITE}
          colorBg={COLORS.TURQUOISE}
          colorBorder={COLORS.TURQUOISE}
          trackingData={{
            actionGA: 'checkPricesKO',
            labelGA: 'date_check',
            categoryGA,
          }}
          onClick={() => onSubmit(suggestion.resortArrivalDate)}
        >
          {buttonLabel}
        </Button>
      </Capsule>
    </div>
  );
}
